import React from "react";
import PropTypes from "prop-types";
import { Translate } from "react-thunk-i18nify";

import { camelize } from "utils/string";

import WholePageSpinner from "components/Spinner/WholePageSpinner";
import CardWithHeader from "components/Card/WithHeader/CardWithHeader";
import SubscriptionNameList from "components/CellPhoneSubscriptionUsage/SubscriptionNameList";
import ConsumedUsage from "components/CellPhoneSubscriptionUsage/ConsumedUsage";

const AllUsagesReport = ({ subscriptionUsage }) => {
  const isConsumedUsagePresent = (usagesByType) =>
    usagesByType.some((usageByType) => Boolean(usageByType.consumed_usage));

  if (!subscriptionUsage) {
    return <WholePageSpinner />;
  }

  const {
    subscriptions: { subscription, add_ons: addOnSubscriptions },
  } = subscriptionUsage;
  const allSubscriptions = [subscription, ...addOnSubscriptions];

  const usageKeys = [
    "domestic",
    "eu",
    "international",
    "eu_roaming",
    "international_roaming",
  ];
  const allUsageReports = Object.keys(subscriptionUsage).map((key) => {
    if (!usageKeys.includes(key)) return <></>;

    const usageType = key;

    const isMainUsageType = ["domestic", "eu_roaming"].includes(usageType);

    const usages = subscriptionUsage[usageType];

    if (!isMainUsageType && !isConsumedUsagePresent(usages)) return <></>;

    const translationKey = `cellPhoneSubscriptionUsage.${camelize(usageType)}`;

    return (
      <CardWithHeader
        title={<Translate value={translationKey} />}
        className="shadow-sm"
        cardContent={<ConsumedUsage usages={usages} />}
      />
    );
  });

  return (
    <div className="detail-view-wrapper">
      <CardWithHeader
        title={<Translate value="attributes.subscriptions" />}
        className="shadow-sm"
        cardContent={<SubscriptionNameList subscriptions={allSubscriptions} />}
      />

      {allUsageReports}
    </div>
  );
};

AllUsagesReport.defaultProps = {};

AllUsagesReport.propTypes = {
  subscriptionUsage: PropTypes.shape({
    subscriptions: PropTypes.shape({
      subscription: PropTypes.string,
      add_ons: PropTypes.arrayOf(PropTypes.string),
    }),
    domestic: PropTypes.shape({
      usage_type: PropTypes.string,
      subscribed_usage: PropTypes.number,
      consumed_usage: PropTypes.number,
      consumed_percentage: PropTypes.number,
      usage_metric: PropTypes.string,
    }),
    eu_roaming: PropTypes.shape({
      usage_type: PropTypes.string,
      subscribed_usage: PropTypes.number,
      consumed_usage: PropTypes.number,
      consumed_percentage: PropTypes.number,
      usage_metric: PropTypes.string,
    }),
    eu: PropTypes.shape({
      usage_type: PropTypes.string,
      subscribed_usage: PropTypes.number,
      consumed_usage: PropTypes.number,
      consumed_percentage: PropTypes.number,
      usage_metric: PropTypes.string,
    }),
    international: PropTypes.shape({
      usage_type: PropTypes.string,
      subscribed_usage: PropTypes.number,
      consumed_usage: PropTypes.number,
      consumed_percentage: PropTypes.number,
      usage_metric: PropTypes.string,
    }),
    international_roaming: PropTypes.shape({
      usage_type: PropTypes.string,
      subscribed_usage: PropTypes.number,
      consumed_usage: PropTypes.number,
      consumed_percentage: PropTypes.number,
      usage_metric: PropTypes.string,
    }),
  }).isRequired,
};

export default AllUsagesReport;
